import axios, { ResponseType } from "axios";
import { S3 } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";
import { SERVER_URL } from "../config/config";

class EventService {
  private static serverURL = SERVER_URL;

  // Construct S3 client with conditional credentials to satisfy @aws-sdk types
  private static s3 = (() => {
    const region = "us-east-1";
    const accessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
    const secretAccessKey = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
    const config: any = { region };
    if (accessKeyId && secretAccessKey) {
      config.credentials = { accessKeyId, secretAccessKey };
    }
    return new S3(config);
  })();

  //mavin S3
  // private static s3 = new AWS.S3({
  //   region: "us-east-1",
  //   credentials: {
  //     accessKeyId: "AKIA4JH2TSZR7ZWMPRPM",
  //     secretAccessKey: "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",
  //   },
  // });

  public static async getEventList(searchParameters: any = {}) {
    let parameteres = searchParameters;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      params: parameteres,
    };
    // console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/event`;
    const response = await axios.get(apiUrl, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async createEvent(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createEvent", body);
    //console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/event`;
    const response = await axios.post(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async getViewEventId(Id: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("getViewEventId:", Id);
    const apiUrl = `${this.serverURL}/api/event/${Id}`;
    const response = await axios.get(apiUrl, axiosConfig);
    return response;
  }

  public static async getConfigurableCosts() {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    const apiUrl = `${this.serverURL}/api/event/costs`;
    const response = await axios.get(apiUrl, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async getConfigurableLocation() {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    const apiUrl = `${this.serverURL}/api/event/locations`;
    const response = await axios.get(apiUrl, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async editEvent(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    // console.log("DsbaAdminToken 14:", sessionStorage.getItem("DsbaAdminToken"));
    console.log("Eventinfo(Service):", body);
    const apiUrl = `${this.serverURL}/api/event`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async UploadVideo(
    body: any,
    UniqueEventId: string,
    onUploadProgress?: (data: any) => void
  ) {
    let axiosConfig = {
      headers: {
        // "Content-Type": "application/json;charset=UTF-8",
        "Content-Type": "multipart/form-data",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      onUploadProgress, //call back funtion
    };

    try {
      const apiUrl = `${this.serverURL}/api/event/media/upload/${UniqueEventId}`;
      const response = await axios.post(apiUrl, body, axiosConfig);
      console.log("response", response);
      return response;
    } catch (error) {
      console.error("Error uploading video:", error);
    }
  }

  public static async UploadVideoToS3(
    file: File,
    uniqueEventId: string,
    handleUploadProgress?: (data: any) => void
  ) {
    if (!uniqueEventId) {
      throw new Error("UniqueEventId is required");
    }

    // Define the S3 bucket and key
    const bucketName = "media1.dsba.org";
    //const bucketName = "mavin.dsba.org";
    const key = `cle/${uniqueEventId}/videos/${uniqueEventId}.mp4`;

    // Create the upload parameters
    const params = {
      Bucket: bucketName,
      Key: key,
      Body: file,
      ContentType: file.type,
      // ACL: "public-read", // Adjust permissions as needed
    };

    return new Promise(async (resolve, reject) => {
      try {
        const upload = new Upload({
          client: this.s3,
          params,
        });

        upload.on("httpUploadProgress", (progress: any) => {
          const loaded = (progress.loaded as number) || 0;
          const total = (progress.total as number) || 0;
          const progressPercentage = total
            ? Math.round((loaded / total) * 100)
            : 0;
          handleUploadProgress && handleUploadProgress(progressPercentage);
        });

        const result = await upload.done();

        // v3 Upload doesn't return a `Location` string like v2 managed upload.
        // Construct a virtual-hosted style URL for the uploaded object.
        const fileUrl = `https://${bucketName}.s3.amazonaws.com/${encodeURIComponent(
          key
        )}`;
        console.log("S3 upload response:", result);
        resolve(fileUrl);
      } catch (err) {
        reject(err);
      }
    });

    // try {
    //   console.log("Uploading to S3 with params:", params);

    //   // Upload the file to S3
    //   const uploadResponse = await this.s3.upload(params).promise();
    //   console.log("File uploaded successfully:", uploadResponse);

    //   return uploadResponse;
    // } catch (error) {
    //   console.error("Error uploading to S3:", error);
    //   throw error;
    // }
  }

  public static async UploadMaterial(
    body: any,
    UniqueEventId: string,
    onUploadProgress?: (data: any) => void
  ) {
    let axiosConfig = {
      headers: {
        // "Content-Type": "application/json;charset=UTF-8",
        "Content-Type": "multipart/form-data",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      onUploadProgress, //call back funtion
    };
    console.log("UniqueEventId in service:", UniqueEventId);
    try {
      const apiUrl = `${this.serverURL}/api/event/material/upload/${UniqueEventId}`;
      const response = await axios.post(apiUrl, body, axiosConfig);
      console.log("response", response);
      return response;
    } catch (error) {
      console.error("Error uploading video:", error);
    }
  }

  public static async updateModerator(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("Eventinfo(Service):", body);
    const apiUrl = `${this.serverURL}/api/event/make-as-moderator`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    return response;
  }

  public static async updateSpeaker(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("Eventinfo(Service):", body);
    const apiUrl = `${this.serverURL}/api/event/make-as-speaker`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    return response;
  }

  public static async updateAttendee(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("Eventinfo(Service):", body);
    const apiUrl = `${this.serverURL}/api/event/make-as-attendee`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    return response;
  }

  public static async markAttendence(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("Eventinfo(Service):", body);
    const apiUrl = `${this.serverURL}/api/event/mark-attendece`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    return response;
  }

  public static async unmarkAttendence(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("Eventinfo(Service):", body);
    const apiUrl = `${this.serverURL}/api/event/unmark-attendece`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    return response;
  }

  public static async creditAttendence(body: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("Eventinfo(Service):", body);
    const apiUrl = `${this.serverURL}/api/event/attendece-credit`;
    const response = await axios.put(apiUrl, body, axiosConfig);
    return response;
  }

  public static async getMember(Id: number) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    const apiUrl = `${this.serverURL}/api/member/` + Id;
    const response = await axios.get(apiUrl, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async downloadAttendenceReport(searchParameters: any) {
    console.log("downloadAttendenceReport");
    let parameteres = searchParameters;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      params: parameteres,
      responseType: "arraybuffer" as ResponseType,
    };
    console.log("axiosConfig", axiosConfig);
    const apiUrl = `${this.serverURL}/api/event/export`;
    const response = await axios.get(apiUrl, axiosConfig);
    //console.log("response", response);
    return response;
  }

  public static async getMemberEventList(
    searchParameters: any = {},
    memberId: any
  ) {
    let parameteres = searchParameters;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      params: parameteres,
    };
    // console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"));
    const apiUrl = `${this.serverURL}/api/order/events/member/` + memberId;
    const response = await axios.get(apiUrl, axiosConfig);
    console.log("getMemberEventList response", response);
    return response;
  }

  public static async deleteEvent(eventId: any) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("deleteEvent eventId:", eventId);
    const apiUrl = `${this.serverURL}/api/event/${eventId}`;
    const response = await axios.delete(apiUrl, axiosConfig);
    console.log("deleteEvent response", response);
    return response;
  }
}

export default EventService;
